/* eslint-disable camelcase */
import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import type {
  GenerateMfaSettingsResponseModel,
  VerifyOtpRequestModel,
  VerifyRecoveryCodeRequestModel,
  SendVerificationEmailResponseModel,
  MfaSettingsModel,
  MfaTrustedDeviceModel,
} from './model';
import type {
  GenerateMfaSettingsResponseDto,
  VerifyOtpRequestDto,
  VerifyRecoveryCodeRequestDto,
  SendVerificationEmailResponseDto,
  MfaSettingsDto,
  MfaTrustedDeviceDto,
} from './dto';

export const mapGenerateMfaSettingsDtoToModel = ({
  enabled,
  recovery_codes,
  uri,
}: GenerateMfaSettingsResponseDto): GenerateMfaSettingsResponseModel => ({
  enabled,
  recoveryCodes: recovery_codes,
  uri,
});

export const mapVerifyOtpModelToDto = ({
  otp,
  mfaStateKey,
  rememberDevice,
}: VerifyOtpRequestModel): VerifyOtpRequestDto => ({
  otp,
  mfa_state_key: mfaStateKey,
  remember_device: rememberDevice,
});

export const mapVerifyRecoveryCodeModelToDto = ({
  recoveryCode,
  mfaStateKey,
}: VerifyRecoveryCodeRequestModel): VerifyRecoveryCodeRequestDto => ({
  recovery_code: recoveryCode,
  mfa_state_key: mfaStateKey,
});

export const mapSendVerificationEmailResponseDtoToModel = ({
  status,
  verification_id,
}: SendVerificationEmailResponseDto): SendVerificationEmailResponseModel => {
  return {
    status,
    verificationId: verification_id,
  };
};

export const mapMfaSettingsDtoToModel = (dto: MfaSettingsDto): MfaSettingsModel =>
  keysToCamelCase(dto);

export const mapMfaTrustedDeviceDtoToModel = (dto: MfaTrustedDeviceDto): MfaTrustedDeviceModel =>
  keysToCamelCase(dto);
